import { Component } from '@theme/component';

class EmeSlideshowArrowFocus extends Component {
  #scroller = null;
  #previous = null;
  #next = null;
  #fits = false;
  #mutationObserver = new MutationObserver((records) => {
    for (const { target } of records) this.#onArrowChange(target);
  });
  #resizeObserver = new ResizeObserver(() => this.#update());

  connectedCallback() {
    super.connectedCallback();
    const slideshow = this.closest('slideshow-component');
    this.#scroller = slideshow?.querySelector('slideshow-slides') ?? null;
    this.#previous = slideshow?.querySelector('slideshow-arrows .slideshow-control--previous') ?? null;
    this.#next = slideshow?.querySelector('slideshow-arrows .slideshow-control--next') ?? null;
    for (const arrow of [this.#previous, this.#next]) {
      if (arrow) this.#mutationObserver.observe(arrow, { attributes: true, attributeFilter: ['disabled'] });
    }
    if (this.#scroller) this.#resizeObserver.observe(this.#scroller);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#mutationObserver.disconnect();
    this.#resizeObserver.disconnect();
  }

  #onArrowChange(arrow) {
    if (!(arrow instanceof HTMLButtonElement)) return;
    if (this.#fits && !arrow.disabled) {
      arrow.disabled = true;
      return;
    }
    this.#keepFocus(arrow);
  }

  #update() {
    const scroller = this.#scroller;
    if (!scroller || scroller.clientWidth === 0) return;
    const wasFitting = this.#fits;
    this.#fits = scroller.scrollWidth <= scroller.clientWidth + 1;
    if (this.#fits) {
      this.#setDisabled(this.#previous, true);
      this.#setDisabled(this.#next, true);
      return;
    }
    if (!wasFitting) return;
    this.#setDisabled(this.#previous, scroller.scrollLeft <= 1);
    this.#setDisabled(this.#next, scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 1);
  }

  #setDisabled(arrow, value) {
    if (arrow instanceof HTMLButtonElement && arrow.disabled !== value) arrow.disabled = value;
  }

  #keepFocus(arrow) {
    if (!arrow.disabled || arrow !== document.activeElement) return;
    for (const control of [this.#previous, this.#next]) {
      if (control === arrow || !(control instanceof HTMLButtonElement) || control.disabled) continue;
      control.focus();
      return;
    }
  }
}

if (!customElements.get('eme-slideshow-arrow-focus')) customElements.define('eme-slideshow-arrow-focus', EmeSlideshowArrowFocus);
